import { useEffect } from 'react'
import { I18nextProvider } from 'react-i18next'
import { BrowserRouter } from 'react-router'

import { storageKey, useApplicationStore } from '../infrastructure'
import AuthProvider from './AuthProvider'
import { Notifications } from './components/Notifications'
import Router from './components/Routes'
import i18n from './i18n'

const App = () => {
  const rehydrate = useApplicationStore.persist.rehydrate

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === storageKey) {
        // When persisted data changes, rehydrate Zustand state
        void rehydrate()
      }
    }

    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  }, [rehydrate])

  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </AuthProvider>
      <Notifications />
    </I18nextProvider>
  )
}

export default App
